import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/ChangePassword/ChangePassword.module.scss'
import { AppDispatch } from '@src/store/store'
import { ChangePasswordForm } from '@src/pages/ChangePassword/ChangePasswordForm'
import { selectIsLoading } from '@src/store/ducks/auth/selectors'
import { selectUserChangePassword } from '@src/store/ducks/user/selectors'
import { Modal } from '@src/components/Modal/Modal'
import { setSuccessChangePassword } from '@src/store/ducks/user/reducer'

export const ChangePassword = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isLoading = useSelector(selectIsLoading)
  const successChange = useSelector(selectUserChangePassword)

  return (
    <>
      <div className={style.changePassword}>
        <ChangePasswordForm isLoading={isLoading} />
      </div>
      <Modal close={() => dispatch(setSuccessChangePassword(false))} isOpen={successChange}>
        <>
          <div className={style.titleModal}>Пароль успешно изменен</div>
        </>
      </Modal>
    </>
  )
}
